// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"70129cc0","275":"adc59e0a","385":"f4e549ba","401":"fd7ca572","508":"ded23329","530":"28d633a8","663":"db345158","715":"6ef8d312","840":"33c486c2","872":"4d12f976"}[chunkId] + ".chunk.js";
};